import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const entityNucleusOverviewCard: ExtensionDefinition<any> = EntityCardBlueprint.make({
  name: 'nucleus-overview',
  params: {
    filter: 'kind:component',
    loader: async () => {
      const { EntityNucleusOverviewCard } = await import('../components/EntityNucleusOverviewCard');
      return <EntityNucleusOverviewCard />;
    },
  },
});
